<template>
    <div style="margin: 16px;">

        <div style="direction:rtl; max-width: 800px; margin: auto; padding: 8px;">

            <!-- title -->
            <div style=" margin-bottom: 4px; background: white; border-radius: 5px 5px 0px 0px">
                <img style="width:100%; border-radius: 5px 5px 0px 0px"
                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Femail_tq.PNG?alt=media&token=33a0dafb-26aa-4646-8264-1a239a6d6604"/>

                <!-- message to player -->
                <div style="padding: 16px; background:white; font-size: 24px;">

                    <div >
                        שלום מוטי,
                    </div>
                    <div >

                        {{ass_strings.fourWords_thankYouForPlaying[store_langCode_ve.val]}}
                        <b> טרוול קווסט מסביב לעולם </b>
                    </div>

                </div>
            </div>

            <!-- creator message -->
            <div style="background:white; margin-bottom: 4px; padding: 16px; ">
                <div style="font-size: 32px; border-bottom: 2px solid #885ead; margin-bottom: 12px;">
                    <b>הודעה מיוצר המשחק </b>
                </div>

                <div style="margin-bottom:8px">
                    היי תודה רבה ששחקתם ככה וככה אשמח
                </div>


                <div>
                    ----------------
                    <div>
                        דן גדסי
                    </div>
                    <div>
                        050-4092457
                    </div>
                    <div>
                        dan@travelAndQuest.com
                    </div>
                </div>

            </div>

            <!-- more info-->
            <div style="background:white; margin-bottom: 4px; padding: 16px;">

                <hr>

                <table style="width:100%;">
                    <tr>
                        <td>
                            <div style='font-weight: bold; font-size: 20px;text-decoration: underline; '> טרוול קווסט</div>
                            <div>dan@TravelAndQuest.com</div>
                            <div>אשרמן 1 יוסף תל אביב, ישראל</div>
                            <a href="https://TravelQuest.xyz">https://TravelQuest.xyz</a>
                        </td>
                        <td style="text-align: left">
                            <img style="width:90px; border-radius: 16px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);" src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&token=ded9d127-7038-4b0d-8e4c-de571e6eabba"/>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {store_getStateValue_vo, store_var} from "../../store";

    export default {
        name: "v_EmailFinishQuest",
        data(){
            return {
                ass_strings : ass_strings,
                store_langCode_ve : store_getStateValue_vo(store_var.system_langCode)
            }
        }
    }
</script>

<style scoped>
</style>